export const MouvementPersonnel = {
    path: '/mouvement_personnel',
    name: 'mouvement_personnel',
    component: () => import('@/views/Impression/MouvementPersonnel/MouvementPersonnelPage.vue'),
}